import BaseView from './BaseView';
import SectionGroups from '../components/SectionGroups';
import Accordion from '../components/Accordion';
import Menu from '../components/Menu';
import ModuleBackground from '../components/ModuleBackground';
import HomeHero from '../components/HomeHero';
import Showcase from '../components/Showcase';
import CarouselFeed from '../components/CarouselFeed';

let view = null;

class Home extends BaseView {
	constructor(container, current, trigger) {
		super(container);
	}

	init() {
		const groups = new Map([
			[SectionGroups, this.container.querySelectorAll('.section-group')],
			[Accordion, this.container.querySelectorAll('[data-accordion]')],
			[Menu, this.container.querySelectorAll('.c-header-wrapper')],
			[ModuleBackground, this.container.querySelectorAll('[data-module-background]')],
			[HomeHero, this.container.querySelectorAll('[data-home-hero]')],
			[Showcase, this.container.querySelectorAll('[data-showcase]')],
			[CarouselFeed, this.container.querySelectorAll('[data-feed-images]')],
		]);

		super.createModules(groups);
	}
}

export default {
	namespace: 'template-home',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Home(next.container, current, trigger);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
